module.exports = __webpack_public_path__ + "static/img/huawei.4c150ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/img/huawei.png
// module id = 2lga
// module chunks = 18 34 93 95 96 97 98 99 100 101 102